import styles from "./carVendorData.module.scss";
import { useCarVendorData } from "./useCarVendorData";

export function carVendorsData(carVendorData) {
  const {
    vendorListMap,
    getRapidRewardsVendorIds,
    getNonRapidRewardsVendorIds,
    getNoPreference,
    getRapidRewards,
    getAllOthers,
  } = useCarVendorData(carVendorData);

  const allOtherVendorIds = getNonRapidRewardsVendorIds(carVendorData);
  const rapidRewardsVendorIds = getRapidRewardsVendorIds(carVendorData);
  const otherCarVendors = getOtherCarVendors(allOtherVendorIds, vendorListMap);
  const rapidRewardsCarVendors = getRapidRewardVendors(vendorListMap, rapidRewardsVendorIds);
  const noPreference = getNoPreference();
  const rapidRewards = getRapidRewards();
  const allOthers = getAllOthers();

  function getRapidRewardVendors(mapFn, rewardIds) {
    const vendorList = rewardIds.map(mapFn);
    const lastElement = vendorList.pop();

    lastElement.className = styles.separator;
    vendorList.push(lastElement);

    return vendorList;
  }

  function getOtherCarVendors(allIds, mapFn) {
    return allIds.map(mapFn);
  }

  return [noPreference, rapidRewards, ...rapidRewardsCarVendors, allOthers, ...otherCarVendors];
}
